import { BaseCourseDeepLinkParameters } from '@lx/quote-tool/shared/types';

/**
 * Type for representing the parameters of the Study and Stay deep link in Quote Tool Lite.
 */
export type QTLiteStudyAndStayDeepLinkParameters = BaseCourseDeepLinkParameters;

/**
 * Type for representing the raw deep link parameters before Zod validation/coercion.
 * The startDate is kept as a string to allow Zod's z.coerce.date() to handle validation,
 * preventing uncaught exceptions during APP_INITIALIZER if the date format is invalid.
 */
export type QTLiteStudyAndStayRawDeepLinkParameters = Omit<BaseCourseDeepLinkParameters, 'startDate'> & {
  startDate?: string;
};
